export default __webpack_public_path__ + "static/media/FAQ.75880fa0.png";